
export const periods = [
    '2026-04-06',
    '2026-04-13',
    '2026-04-20',
    '2026-04-27',
];
export const dishes = [
    '5219',
    '4873',
    '4046',
    '3518',
    '5363',
    '5360',
    '5381',
];
